<template>
<div>
    <textarea
        class="form-control border w-100"
        :id="id_computed"
        :required="required"
        :placeholder="placeholder"
        @input="updateValue"
    >{{ request_form[id_computed] ?? '' }}</textarea>
</div>
</template>

<script>
export default {
    name: "FormQuestionFreeText",
    props: {
        id: {
            type: String,
            required: false,
        },
        question: {
            type: Object,
            required: false,
        },
        request_form: {
            type: Object,
            required: false,
        },
        settings: {
            type: Object,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Please type your answer',
        },
    },
    computed: {
        id_computed() {
            return this.id ?? this.question.local_id + '.free-text';
        },
    },
    methods: {
        updateValue() {
            const value = document.getElementById(this.id_computed).value;
            this.$emit('update-value', this.id_computed, value);
        },
    },
};
</script>
